module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_8023.b4d412fb.png";